export function randomIndex(arrLength: number, skips: number[]) {
  const options = Array(arrLength)
    .fill(null)
    .map((_, i) => i)
    .filter((i) => !skips.includes(i));

  return options[Math.floor(Math.random() * options.length)];
}
